// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"on_a bhj_qr bhj_a bhj_w","FaqAskQuestion__outdated":"on_b bhj_vp bhj_xe"};